import { Serializer } from "../resource/serializer.interface";
import { PreferenceForm } from "./preference-form.model";

export class PreferenceFormSerializer implements Serializer {
    fromJson(json: any): PreferenceForm {
        const preferenceForm = new PreferenceForm();
        preferenceForm.id = json.id;
        preferenceForm.activeVersion = json.activeVersion;
        preferenceForm.internalName = json.internalName;
        preferenceForm.preferencesIds = json.preferencesIds;
        preferenceForm.tenantId = json.tenant_id;
        return preferenceForm;
    }

    toJson(preferenceForm: PreferenceForm): any {
        return {
            id: preferenceForm.id,
            activeVersion: preferenceForm.activeVersion,
            internalName: preferenceForm.internalName,
            preferencesIds: preferenceForm.preferencesIds,
            tenant_id: preferenceForm.tenantId
        };
    }
}
